import React from 'react';
import About from '../components/About/About';

const AboutPage = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      <About />
    </div>
  );
};

export default AboutPage;